import { render, staticRenderFns } from "./PreviewSection.vue?vue&type=template&id=36b49df9&scoped=true"
import script from "./PreviewSection.vue?vue&type=script&lang=js"
export * from "./PreviewSection.vue?vue&type=script&lang=js"
import style0 from "./PreviewSection.vue?vue&type=style&index=0&id=36b49df9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b49df9",
  null
  
)

export default component.exports